import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { filter, throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[onInfiniteScroll]'
})
export class InfiniteScrollDirective implements OnInit, OnDestroy {

	private eventSubscription: Subscription;

  	@Output() onInfiniteScroll = new EventEmitter<void>();

	constructor(private elementRef: ElementRef) {}

	ngOnInit () {
		this.eventSubscription = 
			fromEvent(this.elementRef.nativeElement, 'scroll', {capture: true, passive: true})
				.pipe(filter((event: any) => event.target.scrollTop > (event.target.scrollHeight - event.target.offsetHeight - 200)), throttleTime(500))
				.subscribe(() => this.onInfiniteScroll.emit());
	}

	ngOnDestroy () {
		this.eventSubscription.unsubscribe();
	}
}
